import { useAuth } from '../../contexts/AuthContext';

/** New Canales / Auspiciadores format IA. Follows the company `clips` product, not the Clips rollout allowlist. */
export function useExplorerClipsIa(): boolean {
    const { hasProductAccess } = useAuth();
    return hasProductAccess('clips');
}
